import { rem } from 'polished';
import styled from 'styled-components';

const UseToolsHorizontalScrollItem = styled.li`
    margin: ${rem(0)} ${({ isFirst, isLast }) => (!isFirst || !isLast ? rem(4) : 0)};
`;

export default UseToolsHorizontalScrollItem;
